const state = {
    complaints: [],
    complaintId: [],
    newComplaint: {},
    feedback: [],
    loading: false
};

export default state;